/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Month_SepInputs */

const en_better_studio_month_sep = /** @type {(inputs: Better_Studio_Month_SepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sep`)
};

/**
* | output |
* | --- |
* | "Sep" |
*
* @param {Better_Studio_Month_SepInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_month_sep = /** @type {((inputs?: Better_Studio_Month_SepInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Month_SepInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_month_sep(inputs)
});